<template>
  <Modal
    @close="$emit('close')"
    :showModal="showModal"
    :isLoading="isLoading"
    class="modal-track-order"
  >
    <template v-slot:header>
      <div>
        <h3 class="text-h3">{{ $t('modalTrackOrder.title') }}</h3>
      </div>
    </template>
    <template v-slot:body>
      <div>
        <p class="modal-track-order__text">
          {{ $t('modalTrackOrder.description') }}
        </p>

        <HintBar
          class="modal-track-order__hintbar"
          v-if="showError"
          :hintData="hintFormError"
        />

        <form class="modal-track-order__form" @submit.prevent="submitForm">
          <FormGroup
            v-model.trim="$v.form.orderNumber.$model.value"
            @input="$emit('fieldChanged', form.orderNumber)"
            :field="$v.form.orderNumber"
            :isValidationRun="isValidationRun"
            :class="{'form-group--error': showError}"
          />

          <FormGroup
            v-model.trim="$v.form.email.$model.value"
            @input="$emit('fieldChanged', form.email)"
            :field="$v.form.email"
            :isValidationRun="isValidationRun"
            :class="{'form-group--error': showError}"
          />
          <button
            :disabled="isLoading"
            type="submit"
            class="modal-track-order__submit button button--primary"
          >{{ $t('header.trackOrder') }}</button>
        </form>
        <a
          @click.prevent="$emit('loginClicked')"
          href="/login"
          class="modal-track-order__login-link"
        >{{ $t('modalTrackOrder.fullOrderHistory') }}</a>
      </div>
    </template>
    <template v-slot:footer>
      <i18n path="modalTrackOrder.needHelp" class="modal-track-order__help-text" tag="p">
        <a
          @click.prevent="handleHelpLinkClick"
          href="/customer-support"
          class="link"
        >{{ $t('account.addressBook.contactUsLinkText') }}</a>
      </i18n>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'

import settings from '@/settings'
import FormValidationMixin from '@/mixins/FormValidationMixin'
import LoaderMixin from '@/mixins/LoaderMixin'
import Modal from '@/components/modal/Modal'
import HintBar from '@/components/HintBar'
import FormGroup from '@/components/FormGroup'

export default {
  name: 'ModalTrackOrder',
  components: {
    Modal,
    HintBar,
    FormGroup
  },
  mixins: [FormValidationMixin, LoaderMixin],
  props: ['showModal'],
  computed: {
    ...mapState('orders', ['trackOrderData'])
  },
  methods: {
    ...mapActions('orders', ['trackGuestOrder']),
    submitForm () {
      this.withPresendRoutine(() => {
        this.showError = false
        const formData = {}
        this.pushFormToData(formData)

        this.sendForm(this.trackGuestOrder, formData)
          .then(() => {
            this.isRedirectOnSubmit = true
            this.$emit('close')
            this.$router.push({
              path: `/track-order/${this.trackOrderData?.id}`,
              query: this.getQueryOnDestroy()
            })
          }).catch(() => {
            this.showError = true
          })
      })
    },
    getQueryOnDestroy () {
      const query = { ...this.$route.query, [settings.app.queryTokens.orderEmail]: this.form.email.value }
      delete query[settings.app.queryTokens.openTrackOrderOnInitToken]
      return query
    },
    handleHelpLinkClick () {
      this.$emit('close')
      this.$router.push('/customer-support')
    }
  },
  beforeDestroy () {
    if (!this.isRedirectOnSubmit) this.$router.replace({ query: this.getQueryOnDestroy() }).catch(() => {})
  },
  validations () {
    return {
      isRedirectOnSubmit: false,
      form: {
        orderNumber: {
          value: {
            required,
            server: this.server
          }
        },
        email: {
          value: {
            required,
            email,
            server: this.server
          }
        }
      }
    }
  },
  data () {
    return {
      isValidationRun: false,
      showError: false,
      hintFormError: {
        message: this.$t('modalTrackOrder.hintErrorMessage')
      },
      form: {
        orderNumber: {
          placeholder: this.$t('modalTrackOrder.form.orderNumber.placeholder'),
          value: '',
          title: 'orderNumber',
          type: 'text',
          variant: 'shadow',
          maxLength: '255',
          errors: {
            required: this.$t('modalTrackOrder.form.orderNumber.requiredError')
          }
        },
        email: {
          placeholder: this.$t('modalTrackOrder.form.email.placeholder'),
          value: '',
          type: 'email',
          title: 'orderEmail',
          variant: 'shadow',
          errors: {
            required: this.$t('modalTrackOrder.form.email.requiredError'),
            email: this.$t('modalTrackOrder.form.email.requiredError')
          }
        }
      }
    }
  }
}
</script>
